import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexProps } from '@spazious/dollhouse-uikit';

export interface CanvasTrackerProps extends FlexProps {
  children?: React.ReactNode;
}

export const CanvasTracker = styled(
  forwardRef<HTMLDivElement, CanvasTrackerProps>(({ children, ...restProps }, ref) => {
    return (
      <Flex ref={ref} {...restProps}>
        {children}
      </Flex>
    );
  })
)
  .attrs({
    grow: true,
  })
  .withConfig({
    displayName: 'CanvasTracker',
  })`
position: absolute;
inset: 0;
z-index: 0;
`;
